











import Vue from 'vue'

interface Methods {
  handleClick: () => void
}

interface Props {
  label: string
}

export default Vue.extend<{}, Methods, {}, Props>({
  props: {
    label: {
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
})
